import { render, staticRenderFns } from "./WechatPay_view.vue?vue&type=template&id=ebe7d7de&scoped=true&"
import script from "./WechatPay_view.vue?vue&type=script&lang=js&"
export * from "./WechatPay_view.vue?vue&type=script&lang=js&"
import style0 from "./WechatPay_view.vue?vue&type=style&index=0&id=ebe7d7de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe7d7de",
  null
  
)

export default component.exports